import { useState } from "react";
import { useParams } from "react-router";
import {
	ModifyEventRSVPersRequest,
	ModifyRSVPersForEventResponse,
} from "../../../../../../common/sesh_types";
import { DashboardUtils } from "../../../dashboard_utils";
import { trpc } from "../../../utils/trpc";
import { useUserContext } from "../hooks/use_user_context";
import { MembersSearchDropdown } from "../members_search_dropdown";
import { getOptionStringified, WebRSVPOption } from "./rsvp_list";
import { Constants } from "../../../../../../common/constants";

async function addRSVPersToEvent(request_body: ModifyEventRSVPersRequest) {
	return fetch(`/api/add_rsvpers_to_event`, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify(request_body),
	}).then((response) =>
		response.json().then((value: ModifyRSVPersForEventResponse) => {
			if ("err" in value) {
				DashboardUtils.ShowDefaultErrorAlert(value.err);
				return;
			}

			return value;
		})
	);
}

export function RSVPModal(props: {
	current_rsvp_ids: string[];
	rsvp_option: WebRSVPOption;
	closeModal: () => void;
}) {
	const user_context = useUserContext();

	let { server_id, message_id } = useParams<{
		server_id: string;
		message_id: string;
	}>();

	const context = trpc.useContext();

	const [pending_user_ids, setPendingUserIds] = useState<string[]>([]);
	const [is_loading, setIsLoading] = useState(false);

	const title = (
		<span>
			<i className="title-icon fas fa-user-plus"></i>
			Select Users to Add
		</span>
	);

	const ids_to_ignore = props.current_rsvp_ids;

	let member_select = (
		<MembersSearchDropdown
			selected_ids={pending_user_ids}
			onUpdate={setPendingUserIds}
			disabled_ids={ids_to_ignore}
			guild_id={server_id}
			limit={Constants.MODIFY_RSVPERS_LIMIT}
		/>
	);

	const content = (
		<div className="columns is-mobile is-multiline">
			<div className="column is-full !mb-0 pb-0">
				<p className="note">
					Selected users will be informed of RSVP via direct message.
				</p>
			</div>
			<div className="column is-full">{member_select}</div>
			<div className="column is-full">
				<div className="is-pulled-right">
					<button
						className={`button dashboard-primary-button--tiny is-size-6 has-text-right ${
							is_loading ? "is-loading" : ""
						}`}
						type="submit"
						disabled={pending_user_ids.length === 0}
						onClick={() => {
							setIsLoading(true);
							addRSVPersToEvent({
								access_token: user_context.access_token,
								token_type: user_context.token_type,
								event_id: message_id,
								guild_id: server_id,
								option_emoji: props.rsvp_option.emoji,
								rsvpers_to_modify: pending_user_ids,
							}).then((val) => {
								setIsLoading(false);

								context.event.rsvpedUsers.invalidate({
									guild_id: server_id,
									message_id,
								});
								props.closeModal();
							});
						}}
					>
						<span className="has-text-weight-bold">Add Users</span>
					</button>
				</div>
			</div>
		</div>
	);

	return (
		<DashboardUtils.SeshModal
			is_active={true}
			title={title}
			subtitle={getOptionStringified(props.rsvp_option)}
			allow_overflow
			content={content}
			onClose={props.closeModal}
		/>
	);
}
